import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('BILoggerProvider');
export const BILoggerProvider = Provider;
export const BILoggerConsumer = Consumer;
export const BILoggerContext = Context;
export const useBILogger = useContext;
//# sourceMappingURL=BILoggerProvider.js.map